(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderComponent',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#fitbuildercomponent-component_start_date-date').on('dp.change', function dateChange(e) {
			var start_date     = e.date,
				end_date       = $('#fitbuildercomponent-component_end_date-date').data('DateTimePicker'),
				component_type = $('#fitbuildercomponent-component_type').val(),
				is_custom      = $('#fitbuildercomponent-component_details_type-1').is(':checked');

			if (end_date.date() === null || end_date.date().isBefore(start_date) === true) {
				if (component_type === 'excursion' || component_type === 'transfer' || is_custom === true) {
					end_date.date(start_date).date(e.date.add(0, 'days'));
				} else {
					end_date.date(start_date).date(e.date.add(1, 'days'));
				}
			}
		});

		$('.packaged_by > .btn-default').click(function _packagedByClicked() {
			var $component_type_select;

			if ($(this).data('type') === 'supplier') {
				$('.component-package-vendor').removeClass('hidden');
			} else {
				$('.component-package-vendor').addClass('hidden');

				// need to reset the options in the select
				if ($('.fitbuilder-resorts').val() === '' && $('.fitbuilderlodging-autocomplete').val() === '') {
					Adzuki.Ajax.get('/FitBuilders/componentTypes/')
					.then(function _adjustSelections(response) {
						$component_type_select = $('.component-type');
						$component_type_select.empty();
						$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

						$.each(response, function _iterateTypes(_index, element) {
							$component_type_select.append($('<option>').text(element).attr('value', _index));
						});
					});
				}
			}
		});

		$('.component_detail_type > .btn-default').click(function _packagedByClicked() {
			if ($(this).data('type') === 'supplier') {
				// show vendor fields
				$('.vendor-fields').removeClass('hidden');

				// hide package supplier field if booked through is direct
				if ($('.btn.btn-default.btn-radio.active[data-type="direct"]').length === 1) {
					$('.component-packaged-by.component-package-vendor').addClass('hidden');
				}

				// hide custom component google fields
				$('.fb-places-destination').addClass('hidden');
				$('.fb-places').addClass('hidden');
			} else {
				// hide vendor fields
				$('.vendor-fields').addClass('hidden');

				// show custom component google fields
				$('.fb-places-destination').removeClass('hidden');

				// reset component type
				$('#fitbuildercomponent-component_type').val('');
				$('#fitbuildercomponent-component_type').trigger('change');

				loadGoogleDestinationTypeAhead();
			}
		});

		$('.package-vendor-select').change(function _adjustPackagedComponent() {
			var vendor_id = $(this).val(),
				$component_type_select;

			if (vendor_id.length > 0) {
				Adzuki.Ajax.get('/FitBuilders/packageSupportedTypes/' + vendor_id)
				.then(function _adjustSelections(response) {
					$component_type_select = $('.component-type');
					$component_type_select.empty();
					$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

					$.each(response, function _iterateTypes(index, element) {
						$component_type_select.append($('<option>').text(element).attr('value', index));
					});
				});
			}
		});

		$('.lat').change(function _gotValues() {
			$('#fitbuildercomponent-google_location').prop('disabled', false);
		});

		Adzuki.Typeahead(
			'#fitbuildercomponent-destination_search',
			'/Searches/destination/all/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$('#fitbuildercomponent-destination_id').val(item.id);

				$('#fitbuildercomponent-destination_search').val(item.name);
				$('#fitbuildercomponent-destination_search').prop('disabled', true);
				$('.reset-destination').removeClass('hidden');
			}
		);

		$('#reset-client-link').click(function _resetClient(e) {
			e.preventDefault();

			$('#fitbuildercomponent-client_id').val('');
			$('#fitbuildercomponent-client_search').val('');
			$('#fitbuildercomponent-client_search').prop('disabled', false);
			$('.reset-client').addClass('hidden');
		});

		$('.reset-destination-link').click(function _resetDestination(e) {
			e.preventDefault();

			$('#fitbuildercomponent-destination_search').val('');
			$('#fitbuildercomponent-destination_search').prop('disabled', false);
			$('#fitbuildercomponent-destination_id').val('');

			$('.reset-destination').addClass('hidden');
		});

		$('#reset-vendor').click(function _resetVendor(e) {
			e.preventDefault();

			$('#fitbuildercomponent-vendor_search').val('');
			$('#fitbuildercomponent-vendor_search').prop('disabled', false);
			$('#fitbuildercomponent-vendor_id').val('');
			$('#fitbuildercomponent-title').val('');
			$('.fit-builder-detail-item').html('');

			$('.reset-typeahead').addClass('hidden');
			$('.hide-vendor').addClass('hidden');

			// initialize vendor typeahead
			loadVendorTypeAhead($('.component-type').val());

			Adzuki.Editor('#fitbuildercomponent-description', {
				init_instance_callback: function onEditorInit(_editor) {
					_editor.setContent('');
					$('#fitbuildercomponent-description').val('');
				},
			});
		});

		$('.component-type').change(function _showHideDestination() {
			var component_type    = $(this).val(),
				hide_vendor_label = '';

			$('#reset-vendor').trigger('click');

			switch (component_type) {
				case 'air':
					$('.component-vendor-label').html('Airline');
					$('.fit-builder-destination-container').removeClass('hidden');
					break;
				case 'car':
					$('.component-vendor-label').html('Car Rental Company');
					$('.fit-builder-destination-container').removeClass('hidden');
					break;
				case 'cruise':
					$('.component-vendor-label').html('Cruise Line');
					$('.fit-builder-destination-container').addClass('hidden');
					break;
				case 'excursion':
					$('.component-vendor-label').html('Excursion Company');
					$('.fit-builder-destination-container').addClass('hidden');
					break;
				case 'lodging':
					$('.component-vendor-label').html('Hotel Chain');
					$('.fit-builder-destination-container').removeClass('hidden');
					break;
				case 'package':
					$('.component-vendor-label').html('Package Supplier');
					$('.fit-builder-destination-container').removeClass('hidden');
					break;
				case 'rail':
					$('.component-vendor-label').html('Rail Company');
					$('.fit-builder-destination-container').removeClass('hidden');
					break;
				case 'transfer':
					$('.component-vendor-label').html('Transfer Company');
					$('.fit-builder-destination-container').removeClass('hidden');
					break;
				default:
					// no component type selected, make field label generic
					$('.component-vendor-label').html('Vendor');
					break;
			}

			// update the "hide vendor" field label based on selected component type
			hide_vendor_label = $('.component-vendor-label').text();

			$('.component-hide-vendor-label').html('Hide ' + hide_vendor_label + ' in Trip Summary');

			loadVendorTypeAhead(component_type);
		});

		$('.fit-builder-detail-item').on('change', '.fitbuilder-resorts', function _geResortDetails() {
			var num         = $(this).data('i'),
				property_id = $(this).val(),
				hotel_address;

				$('.fitbuilderlodging-giata_id[data-i="' + num + '"]').val('');
				$('.fitbuilderlodging-autocomplete[data-i="' + num + '"]').val('');

			Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
				$('.fitbuilderlodging-image_url[data-i="' + num + '"]').val(property.image);
				$('.fit-builder-hotel-image[data-i="' + num + '"]').html('<img style="margin: 10px 0px 10px 0px; max-width: 300px" src="' + Adzuki.base_uri + '/' + property.image + '">');

				$('#fitbuildercomponent-title').val(property.name);

				Adzuki.Editor('#fitbuildercomponent-description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(property.long_description);
						$('#fitbuildercomponent-description').val(property.long_description);
					},
				});

				hotel_address = property.address + '|';
				hotel_address += property.latitude + '|';
				hotel_address += property.longitude;

				$('.fitbuilderlodging-address[data-i="' + num + '"]').val(hotel_address);

				if (property.country_id) {
					$('#fitbuildercomponent-destination_search').val(property.country);
					$('#fitbuildercomponent-destination_search').prop('disabled', true);
					$('#fitbuildercomponent-destination_id').val('countries_' + property.country_id);
					$('.reset-destination').removeClass('hidden');
				}
			});
		});

		// get sailings
		$('.fit-builder-detail-item').on('change', '.fit-builder-ships', function _getSailings() {
			var keyParts,
				num               = $(this).data('i'),
				sailing_selection = $('.fit-builder-sailings[data-i="' + num + '"]'),
				url               = '/CruiseSearch/getSailings/' + $(this).val() + '/1';

			sailing_selection.empty();
			sailing_selection.append($('<option>').text('Choose Sailing').attr('value', ''));

			Adzuki.Ajax.get(url).then(function success(data) {
				$.each(data, function parseSailings(key, value) {
					keyParts = key.split("|");

					sailing_selection.append($('<option>').text(value).attr('value', keyParts[1]));
				});
			});

			sailing_selection.focus();
		});

		$('.fit-builder-detail-item').on('change', '.fit-builder-sailings', function _getSailings() {
			Adzuki.Ajax.get('/FitBuilders/sailing/' + $(this).val()).then(function success(data) {
				$('#fitbuildercomponent-component_start_date-date').data("DateTimePicker").date(data.start_date);
				$('#fitbuildercomponent-component_end_date-date').data("DateTimePicker").date(data.end_date);
				$('#fitbuildercomponent-title').val(data.title);

				Adzuki.Editor('#fitbuildercomponent-description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(data.description);
						$('#fitbuildercomponent-description').val(data.description);
					},
				});

				if (data.subregion_id) {
					$('#fitbuildercomponent-destination_search').val(data.subregion);
					$('#fitbuildercomponent-destination_search').prop('disabled', true);
					$('#fitbuildercomponent-destination_id').val('subregions_' + data.subregion_id);
					$('.reset-destination').removeClass('hidden');
				}
			});
		});

		$('.fit-builder-detail-item').on('click', '#reset-viator-destination-link', function _resetVendor(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.fitbuilderviator-destination_id[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-destination_id[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').prop('disabled', false);
			$('.reset-viator-destination[data-i="' + num + '"]').addClass('hidden');
			$('.viator-selection[data-i="' + num +'"]').removeClass('hidden');

			$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').val('');
			$('.fitbuilderexcursion-product_code[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').prop('disabled', false);
			$('.viator-selection[data-i="' + num + '"]').addClass('hidden');
			$('.fit-builder-viator-image[data-i="' + num + '"]').html('');
		});

		$('.fit-builder-detail-item').on('click', '#reset-hotel-link', function _resetHotel(e) {
			e.preventDefault();

			$('.fitbuilderlodging-autocomplete').val('');
			$('.fitbuilderlodging-image_url').val('');
			$('.fitbuilderlodging-giata_id').val('');
			$('.fitbuilderlodging-address').val('');
			$('.fitbuilderlodging-autocomplete').prop('disabled', false);
			$('.reset-hotel').addClass('hidden');

			$('.fit-builder-hotel-image').html('');
		});

		$('#reset-google-destination-link').click(function _resetGoogleDestination(e) {
			e.preventDefault();

			$('#fitbuildercomponent-google_destination').val('');
			$('#fitbuildercomponent-google_destination').prop('disabled', false);
			$('#fitbuildercomponent-google_location').prop('disabled', true);

			$('.reset-google-destination').addClass('hidden');

			$('.fb-places').addClass('hidden');
			$('#reset-google-location-link').trigger('click');
		});

		$('#reset-google-location-link').click(function _resetGoogleLocation(e) {
			e.preventDefault();
			$('#fitbuildercomponent-google_location').val('');
			$('#fitbuildercomponent-google_location').prop('disabled', false);
			$('.fit-builder-google-image').html('');
			$('#fitbuildercomponent-fit_builder_google_component_image').val('');
			$('.reset-google-location').addClass('hidden');
		});

		// load typeaheads
		if ($('#fitbuildercomponent-component_type').val() !== '') {
			switch ($('#fitbuildercomponent-component_type').val()) {
				case 'cruise':
					$('.set-details').addClass('hidden');
				break;
				case 'excursion':
					if ($('.fitbuilderviator-destination_id').vall() !== "") {
						loadViatorDestinationSearch(1);
						loadViatorProductTypeAhead(1, $('.fitbuilderviator-destination_id').vall());
					}

					$('.set-details').addClass('hidden');
				break;
				case 'lodging':
					if ($('.fitbuilderlodging-autocomplete').val() !== "") {
						loadHotelTypeAhead(1);
					}

					$('.set-details').addClass('hidden');
				break;
				default:
					// later
					$('.fit-builder-detail-item[data-i="1"]').addClass('hidden');
					$('.set-details').removeClass('hidden');
				break;
			}
		}

		if ($('#fitbuildercomponent-fit_builder_id').val() !== '') {
			loadGoogleDestinationTypeAhead();
		}

		$(document).on('click', '.btn-radio', function _switchProperty() {
			var i = $(this).data('i');
			
			if ($(this).data('type') === 'inclusive') {
				$('.all-inclusive-' + i).removeClass('hidden');
				$('.regular-properties-' + i).addClass('hidden');
			} else {
				$('[name="form_component_data[FitBuilderComponent][hotel][' + i + ']"]').prop('selectedIndex', 0);
				$('.all-inclusive-' + i).addClass('hidden');
				$('.regular-properties-' + i).removeClass('hidden');
				loadHotelTypeAhead(i);
			}
		});
	};

	function handleCruise(item, num)
	{
		Adzuki.Ajax.get('/FitBuilders/ships/' + item.id + '/' + num + '/component')
		.then(function _showCruiseFields(html) {
			$('.fit-builder-detail-item[data-i="' + num +'"]').html(html);
		});
	}

	function handleLodging(item, num)
	{
		var hotel_template,
			property_template,
			start_time,
			end_time;

		start_time = new Date(2022, 0, 1, 15, 0, 0, 0);
		end_time   = new Date(2022, 0, 1, 11, 0, 0, 0);

		$('#fitbuildercomponent-component_start_date-time').data("DateTimePicker").date(start_time);
		$('#fitbuildercomponent-component_end_date-time').data("DateTimePicker").date(end_time);

		Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + item.id).then(function success(properties) {
			var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

			// if we can get all-inclusive properties for the lodging vendor, do it
			if (sorted_properties.length > 0) {
				property_template = ''
					+ '<div class="form-group property-type">'
						+ '<label class="col-sm-3 control-label">Property Type</label>'
						+ '<div class="col-sm-9">'
							+ '<div class="radio-group packaged_by" data-toggle="buttons">'
								+ '<label class="btn btn-default btn-radio active" data-type="inclusive" data-i="' + num + '">'
								+ '<input type="radio" class="radio-inline property_type" value="inclusive" name="form_component_data[FitBuilder][property_type][' + num + ']" id="fitbuilder-property_type-' + num + '">'
									+ 'All-Inclusive Property'
								+ '</label>&nbsp;'
								+ '<label class="btn btn-default btn-radio" data-type="regular" data-i="' + num + '">'
								+ '<input type="radio" class="radio-inline property_type" value="regular" name="form_component_data[FitBuilder][property_type][' + num + ']" id="fitbuilder-property_type-' + num + '">'
									+ 'Regular Property'
								+ '</label>'
							+ '</div>'
						+ '</div>'
					+ '</div>'
					+ '<div class="form-group hotel-select all-inclusive-' + num + '">'
						+ '<label class="control-label col-sm-3">All-Inclusive Resort</label>'
						+ '<div class="col-sm-9">'
							+ '<input type="hidden" name="form_component_data[FitBuilderComponent][hotel_address][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-address" value="">'
							+ '<input type="hidden" name="form_component_data[FitBuilderComponent][image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-image_url" value="">'
							+ '<select name="form_component_data[FitBuilderComponent][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilder-resorts">'
							+ '</select>'
							+ '<div class="fit-builder-hotel-image" data-i="' + num + '"></div>'
						+ '</div>'
					+ '</div>';

					$('.fit-builder-detail-item[data-i="' + num +'"]').html(property_template);
					$('.fitbuilder-resorts[data-i="' + num + '"]').empty();
					$('.fitbuilder-resorts[data-i="' + num + '"]').append($('<option>').text('Please Select').attr('value', ''));

					$.each(sorted_properties, function loadProperty(i, property) {
						$('.fitbuilder-resorts[data-i="' + num + '"]').append($('<option>').text(property.value).attr('value', property.key));
					});

					hotel_template = ''
					+ '<div class="form-group hotel-select regular-properties-' + num + ' hidden">'
						+ '<label class="control-label col-sm-3">Hotel Name</label>'
						+ '<div class="col-sm-9">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][hotel_address][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-address" value="">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][giata_id][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-giata_id" value="">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-image_url" value="">'
							+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilder][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-autocomplete" value="">'
							+ '<span class="reset-hotel hidden" data-i="' + num + '">'
								+ '<a href="#" id="reset-hotel-link" data-i="' + num + '">Reset Hotel</a>&nbsp;&nbsp;&nbsp;'
							+ '</span>'
							+ '<div class="fit-builder-hotel-image" data-i="' + num + '"></div>'
						+ '</div>'
					+ '</div>';
	
					$('.fit-builder-detail-item[data-i="' + num +'"]').append(hotel_template);
	
					loadHotelTypeAhead(num);
			} else { // otherwise, use hotel engine to get the data
				hotel_template = ''
				+ '<div class="form-group hotel-select ">'
					+ '<label class="control-label col-sm-3">Hotel Name</label>'
					+ '<div class="col-sm-9">'
						+ '<input type="hidden" name="form_component_data[FitBuilderComponent][hotel_address][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-address" value="">'
						+ '<input type="hidden" name="form_component_data[FitBuilderComponent][giata_id][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-giata_id" value="">'
						+ '<input type="hidden" name="form_component_data[FitBuilderComponent][image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-image_url" value="">'
						+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilderComponent][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-autocomplete" value="">'
						+ '<span class="reset-hotel">'
							+ '<a href="#" id="reset-hotel-link">Reset Hotel</a>&nbsp;&nbsp;&nbsp;'
						+ '</span>'
						+ '<div class="fit-builder-hotel-image" data-i="' + num + '"></div>'
					+ '</div>'
				+ '</div>';

				$('.fit-builder-detail-item[data-i="' + num +'"]').html(hotel_template);

				loadHotelTypeAhead(num);
			}
		});
	}

	function handleViator(item, num)
	{
		var viator_template = ''
		+ '<div class="form-group hotel-select">'
			+ '<label class="control-label col-sm-3">Viator Destination</label>'
			+ '<div class="col-sm-9">'
				+ '<input type="hidden" name="form_component_data[FitBuilderComponent][viator_destination_id][' + num + ']" data-i="' + num + '" class="form-control fitbuilderviator-destination_id" value="">'
				+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilderComponent][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilderviator-autocomplete" value="">'
				+ '<span class="reset-viator-destination hidden"  data-i="' + num + '">'
					+ '<a href="#" id="reset-viator-destination-link" data-i="' + num + '">Reset Viator Destination</a>&nbsp;&nbsp;&nbsp;'
				+ '</span>'
			+ '</div>'
		+ '</div>'
		+ '<div class="form-group hidden viator-selection" data-i="' + num + '">'
			+ '<label class="control-label col-sm-3">Viator Excursion</label>'
			+ '<div class="col-sm-9">'
				+ '<input type="hidden" name="form_component_data[FitBuilderComponent][viator_image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderexcursion-image_url" value="">'	
				+ '<input type="hidden" name="form_component_data[FitBuilderComponent][viator_product_code][' + num + ']" data-i="' + num + '" class="form-control fitbuilderexcursion-product_code" value="">'
				+ '<input type="hidden" name="form_component_data[FitBuilderComponent][viator_product_duration][' + num + ']" data-i="' + num + '" class="form-control fitbuilderexcursion-product_duration" value="">'
				+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilderComponent][viator_excursion][' + num + ']" data-i="' + num + '" class="form-control fitbuilderviator-excursion-autocomplete" value="">'
				+ '<span class="reset-viator-product hidden" data-i="' + num + '">'
					+ '<a href="#" id="reset-viator-product-link" data-i="' + num + '">Reset Viator Excursion</a>&nbsp;&nbsp;&nbsp;'
				+ '</span>'
				+ '<div class="fit-builder-viator-image" data-i="' + num + '"></div>'
			+ '</div>'
		+ '</div>';

		$('.fit-builder-detail-item[data-i="' + num +'"]').html(viator_template);

		loadViatorDestinationSearch(num);
	}

	function loadGooglePlaceTypeAhead(item)
	{
		var description = '',
			image;

		$('#fitbuildercomponent-google_destination').prop('disabled', true);
		$('#fitbuildercomponent-google_location').prop('disabled', false);

		$('.fb-places').removeClass('hidden');
		$('.reset-google-destination').removeClass('hidden');

		Adzuki.Typeahead(
			'#fitbuildercomponent-google_location',
			'/Searches/googlePlaceLookup/' + item.id,
			function select(item, $self, typeahead) {
				$('#fitbuildercomponent-google_location').prop('disabled', true);

				if (item.id) {
					Adzuki.Ajax.get(Adzuki.base_uri + '/Searches/googlePlaceDetails/' + item.id)
					.then(function success(response) {
						$('#fitbuildercomponent-title').val(response.name);

						if (response.images.length > 0) {
							image = Adzuki.base_uri + '/Searches/googleImageConvert/' + response.images[0].photo_reference;

							$('.reset-google-location').removeClass('hidden');
							$('#fitbuildercomponent-fit_builder_google_component_image').val(image);
							$('.fit-builder-google-image').html('<img style="margin: 10px 0px 10px 0px" src="' + image + '">');
						}

						// set the component description to the website
						if (response.website) {
							description += '<p>Website: <a href="' + response.website + '" target="_blank">' + response.website + '</a></p>';
						}

						// and address
						if (response.html_address) {
							description += '<p>Address: ' + response.html_address + '</p>';
						}

						Adzuki.Editor('#fitbuildercomponent-description', {
							init_instance_callback: function onEditorInit(_editor) {
								_editor.setContent(description);
								$('#fitbuildercomponent-description').val(description);
							},
						});
					});
				}
			},
			null,
			null,
			null,
			true
		);
	}

	function loadGoogleDestinationTypeAhead()
	{
		var destination_label;

		Adzuki.Typeahead(
			'#fitbuildercomponent-google_destination',
			'/Searches/googleLocationSearch',
			function select(item, $self, typeahead) {
				if (item.id) {
					loadGooglePlaceTypeAhead(item);
				}

				if (item.city_id) {
					destination_label = item.city_name;

					if (item.city_state_name) {
						destination_label += ', ' + item.city_state_name;
					}

					$('#fitbuildercomponent-destination_search').val(destination_label);
					$('#fitbuildercomponent-destination_search').prop('disabled', true);
					$('#fitbuildercomponent-destination_id').val('cities_' + item.city_id);
					$('.reset-destination').removeClass('hidden');
				}
			},
			null,
			null,
			null,
			true
		);
	}

	function loadHotelTypeAhead(num)
	{
		var hotel_address,
			description;

		Adzuki.Typeahead(
			'.fitbuilderlodging-autocomplete[data-i="' + num + '"]',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);

				$('.reset-hotel').removeClass('hidden');
				$('.fitbuilderlodging-autocomplete[data-i="' + num + '"]').prop('disabled', true);
				$('.fitbuilder-resorts[data-i="' + num + '"]').prepend($('<option>').text('Please Select').attr('value', ''));
				$('[name="form_component_data[FitBuilder][hotel][' + num + ']"]').prop('selectedIndex', 0);

				if (item.giata_id) {
					Adzuki.Ajax.get(Adzuki.base_uri + '/HotelEngine/hotelMetaData/' + item.giata_id)
					.then(function success(response) {
						$('#fitbuildercomponent-title').val(response.name);
						$('.fitbuilderlodging-giata_id[data-i="' + num + '"]').val(item.giata_id);

						if (response.metadata.property.description_rooms) {
							description = response.metadata.property.description_rooms;

							Adzuki.Editor('#fitbuildercomponent-description', {
								init_instance_callback: function onEditorInit(_editor) {
									_editor.setContent(description);
									$('#fitbuildercomponent-description').val(description);
								},
							});
						}

						if (response.street_address_1) {
							hotel_address = response.street_address_1 + '|';
							hotel_address += response.street_address_2 + '|';
							hotel_address += response.city + '|';
							hotel_address += response.state_prov + '|';
							hotel_address += response.postal_code + '|';
							hotel_address += response.country_code + '|';
							hotel_address += response.latitude + '|';
							hotel_address += response.longitude;

							$('.fitbuilderlodging-address[data-i="' + num + '"]').val(hotel_address);
						}

						if (response.metadata.images) {
							response.metadata.images.forEach(function _getImages(image, i) {
								if (image.hero_image === '1') {
									$('.fitbuilderlodging-image_url[data-i="' + num + '"]').val(image.large);
									$('.fit-builder-hotel-image[data-i="' + num + '"]').html('<img style="margin: 10px 0px 10px 0px" src="' + image.medium + '">');
								}
							});
						}

						if (response.city_id) {
							$('#fitbuildercomponent-destination_search').val(response.city_name + ' ' + response.state_prov);
							$('#fitbuildercomponent-destination_search').prop('disabled', true);
							$('#fitbuildercomponent-destination_id').val('countries_' + response.city_id);
							$('.reset-destination').removeClass('hidden');
						}
					});
				}
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else {
					html = item.name;
				}
				return html;
			}
		);
	}

	function loadVendorTypeAhead(component_type)
	{
		$('#fitbuildercomponent-vendor_search').prop('disabled', true);

		Adzuki.Typeahead(
			'#fitbuildercomponent-vendor_search',
			'/Vendors/searchVendorByType/' + component_type + '/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$('#fitbuildercomponent-vendor_id').val(item.id);
				$('#fitbuildercomponent-component_type').val(item.primary_component_type);
				$('.hide-vendor').removeClass('hidden');

				if ($('#fitbuildercomponent-component_type').val() !== item.primary_component_type) {
					$('#reset-vendor').trigger('click');
					Adzuki.StatusMessage('error', 'Sorry, the vendor you chose does not support the component type you selected above.');
				}

				$('#fit-builder-details-type-1').val(item.primary_component_type);
				$('.fit-builder-detail-item[data-i="1"]').removeClass('hidden');

				switch (item.primary_component_type) {
					case 'cruise':
						handleCruise(item, 1);
						$('.set-details').addClass('hidden');
					break;
					case 'excursion':
						if (item.name_without_type.indexOf('Viator') !== -1) {
							handleViator(item, 1);
							$('.set-details').addClass('hidden');
						}
					break;
					case 'lodging':
						handleLodging(item, 1);
						$('.set-details').addClass('hidden');
					break;
					default:
						// later
						$('.fit-builder-detail-item[data-i="1"]').addClass('hidden');
						$('.set-details').removeClass('hidden');
					break;
				}
			},
			null,
			null,
			null,
			true
		);

		if (component_type) {
			$('#fitbuildercomponent-vendor_search').prop('disabled', false);
			$('#fitbuildercomponent-vendor_search').focus();
		}
	}

	function loadViatorDestinationSearch(num)
	{
		Adzuki.Typeahead(
			'.fitbuilderviator-autocomplete[data-i="' + num + '"]',
			'/Viator/destinationSearch',
			function selectDestination(item) {
				$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').val(item.name);
				$('.fitbuilderviator-destination_id[data-i="' + num + '"]').val(item.destination_id);

				$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').prop('disabled', true);
				$('.reset-viator-destination').removeClass('hidden');
				$('.viator-selection[data-i="' + num +'"]').removeClass('hidden');

				loadViatorProductTypeAhead(num, item.destination_id);
			}
		);
	}

	function loadViatorProductTypeAhead(num, viator_destination_id)
	{
		var product_lookup_url = '/Searches/viator/' + viator_destination_id;

		Adzuki.Typeahead(
			'.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]',
			product_lookup_url,
			function selectProduct(item) {
				$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').val(item.name);
				$('.fitbuilderexcursion-product_code[data-i="' + num + '"]').val(item.id);
				$('.fitbuilderexcursion-image_url[data-i="' + num + '"]').val(item.thumbnail_hi_res_url);
				$('.fit-builder-viator-image[data-i="' + num + '"]').html('<img style="margin: 10px 0px 10px 0px" src="' + item.thumbnail_url + '">');
				$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').prop('disabled', true);
				$('.reset-viator-product[data-i="' + num + '"]').removeClass('hidden');
				$('#fitbuildercomponent-title').val(item.name);
				$('.fitbuilderexcursion-product_duration[data-i="' + num + '"]').val(item.duration);

				Adzuki.Editor('#fitbuildercomponent-description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(item.short_description);
						$('#fitbuildercomponent-description').val(item.short_description);
					},
				});

				if (item.price) {
					$('#fitbuildercomponent-quoted_price').val(item.price);
				}

				if (item.city_id) {
					$('#fitbuilder-destination_search').val(item.city_name);
					$('#fitbuilder-destination_search').prop('disabled', true);
					$('#fitbuilder-destination_id').val('cities_' + item.city_id);
					$('.reset-destination').removeClass('hidden');
				}
			}
		);
	}
}(jQuery, window.Adzuki || {}));